/* Calma Bienestar — comparador antes/después */
(function () {
  function init(root) {
    var stage = root.querySelector('.ba__stage');
    var range = root.querySelector('.ba__range');
    if (!stage || !range) return;
    function update() {
      stage.style.setProperty('--pos', range.value + '%');
      range.setAttribute('aria-valuetext', range.value + '% antes');
    }
    range.addEventListener('input', update);
    update();
  }
  function boot() {
    document.querySelectorAll('[data-ba]').forEach(init);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
